import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme(
    /**
     * @see https://mui.com/customization/theming/#theme-configuration-variables
     */
    {
        // direction: "rtl",
        typography: {
            fontFamily: ["Poppins"].join(",")
        },

        palette: {
            contrastThreshold: 2,
            primary: {
                // light: will be calculated from palette.primary.main,
                main: "#5d78ff"
                // dark: will be calculated from palette.primary.main,
                // contrastText: will be calculated to contrast with palette.primary.main
            },
            secondary: {
                // light: will be calculated from palette.primary.main,
                main: "#0abb87",
                // dark: will be calculated from palette.primary.main,
                contrastText: "#ffffff"
            },
            error: {
                // light: will be calculated from palette.primary.main,
                main: "#fd397a"
                // dark: will be calculated from palette.primary.main,
                // contrastText: will be calculated to contrast with palette.primary.main
            }
        },

        /**
         * @see https://mui.com/customization/theme-components/#default-props
         */
        components: {
            // Name of the component ⚛️
            MuiButtonBase: {
                defaultProps: {
                    // The properties to apply
                    disableRipple: true // No more ripple, on the whole application 💣!
                }
            },

            // Set default elevation to 1 for popovers.
            MuiPopover: {
                defaultProps: {
                    elevation: 1
                }
            }
        }
    }
);

export default function ThemeProviderWrapper(props) {
    const { children } = props;

    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
